<div
  data-test="yj0H3ngL"
  class="tabs-switch"
  [ngClass]="{
    'tabs-switch_dark': dark,
    'tabs-switch_light': grayBack,
    'test-width': fullWidth
  }"
>
  <div
    data-test="20AssTyo"
    class="tabs-switch__item"
    (click)="handleSwitch(tab)"
    [ngClass]="{ active: tab.id === activeTab.id }"
    *ngFor="let tab of tabs"
  >
    <span data-test="uHs_36kZ">{{ tab.text }}</span>
  </div>
</div>
